const caseInsensitiveSearch = function(str, searchStr) {
  if (str === undefined || searchStr === undefined) {
    return false;
  }
  return str.toLowerCase().search(new RegExp(searchStr, 'i')) > -1;
};

export { caseInsensitiveSearch };
